import React, { Component } from 'react';

import ReactHtmlParser from 'react-html-parser';

import FrontHeader from '../views/frontend/Header/Header';
import Footer from '../views/frontend/Footer/Footer';

import {designCenterActions}    from '../redux/actions/designCenterActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


let isLoading = false;

class AffiliateLayout extends Component {

  constructor(props, context){
    super(props, context);
    this.state = {
      cartStatus:'',
      themeData: {},
      backgroundStyles: {},
    };
  }

  componentWillMount(){
    const { actions: { getThemeData } } = this.props;
    getThemeData({scheduledDate:new Date()});
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.themeData.data){
      this.setState({
        themeData: nextProps.themeData.data
      });
      if(nextProps.themeData.data.background){
        let bgColor = nextProps.themeData.data.background.background_color;
        let bgImage = nextProps.themeData.data.background.background_image;
        let bgRepeat = (bgColor) ? 'no-repeat' : 'repeat';
        this.setState({
          backgroundStyles: {
            'backgroundColor': bgColor,
            'backgroundImage': `url(${bgImage})`,
            'backgroundPosition': 'center',
            'backgroundRepeat': bgRepeat
          }
        });
      }
    }
  }

  render() {
    const Component = this.props.component;
    const route = this.props.route;
    const user  = this.props.user;
    return (
      <div style={{height:'100%'}}>
        <Component route={route}/>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    error:  state.designCenterReducer.error,
    themeData:  state.designCenterReducer.themeData
  };
};


const mapDispatchToProps = (dispatch) => {
  return {
    actions : bindActionCreators(
      {
        ...designCenterActions,
      },
      dispatch)
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AffiliateLayout);



// WEBPACK FOOTER //
// ./src/app/layout/AffiliateLayout.js